import { useHandler } from '@app/hooks/useHandler.hook';
import { useQuery, useQueryClient } from 'react-query';
import { ETrialOnboardingType } from '../TrialOnboardingDialog';
import { EOnboardingModalType } from '@app/domain/plan/hooks/useTrialPhasesConfig';

class TrialOnboardingState {
  isOpen = false;
  history?: { trialOnboarding: ETrialOnboardingType; modalType?: EOnboardingModalType }[] = [];
}

let globalState: TrialOnboardingState = new TrialOnboardingState();

/**
 * Hook to track state of TrialOnboarding dialog e.g. isOpen
 * to properly render other components on page
 * e.g. to hide other dialogs until TrialOnboarding completed
 */
export const useTrialOnboardingDialogState = () => {
  const queryClient = useQueryClient();
  const { data: state } = useQuery({
    queryKey: [useTrialOnboardingDialogState.queryKey],
    queryFn: () => globalState,
  });
  const setState = useHandler((newState: TrialOnboardingState) => {
    globalState = newState;
    queryClient.setQueryData(useTrialOnboardingDialogState.queryKey, globalState);
  });

  return { state, setState };
};
useTrialOnboardingDialogState.queryKey = 'useTrialOnboardingDialogState';
Object.freeze(useTrialOnboardingDialogState);
